import { reducer as counterReducer } from './Counter'

export default {
    counterReducer
}